class Checkbox {
  constructor($container) {
    this.$container = $container;
    this.$input = this.$container.find('.Checkbox__input');
    this.$sync = $('#' + this.$container.attr('data-sync'));
    this.$input.change(() => {
      if(this.$sync) {
        if(this.$input.prop('checked')) {
          // on
          this.$sync.addClass('sync-checkbox-checked');
        } else {
          // off
          this.$sync.removeClass('sync-checkbox-checked');
        }
      }

    });
  }
}

export default Checkbox;
